<main class="flex flex-col justify-center items-center gap-2 flex-1">
  <h1>{{ errorMessage }}</h1>
  <div class="flex flex-row gap-2">
    <button mat-flat-button (click)="reload()">
      {{ 'Try Again' | translate | uppercase }}
    </button>
  </div>
</main>
